import React, { useContext } from 'react';
import heroImage from '../assets/Header_Image2.png';
import QueryStringContext from './QueryStringContext';

const HeroSection = () => {
  const { f } = useContext(QueryStringContext);

  return (
    <div className="hero-section">
      <img
        src={heroImage}
        alt="Hero Image" 
        className="hero-image" />
      <div className="my-component__overlay"></div>
      <div className="hero-text">
        <div className="auto-scale-text-lg" style={{textAlign: 'center', color:'white', fontWeight:'700', margin:'2vw'}}>THE DESERT NORTH OPPORTUNITY</div>
      </div>
    </div>
  );
};

export default HeroSection;
